import { useContext, useEffect, useState } from 'react';

import { FetchHookState } from './types/FetchHookState';
import { environmentContext } from '../../../environmentContext/environmentContext';
import { GiftCardValidationStatusForCompany } from '../../../types/MetricsValidationStatusForCompany';

export type UseFetchGiftCardStatusForCompanyState = FetchHookState<GiftCardValidationStatusForCompany[]>;

const defaultState: UseFetchGiftCardStatusForCompanyState = {
  data: [],
  loading: true,
};
export const useFetchGiftCardValidationStatus = (integrationType?: string) => {
  const [fetchHookState, setFetchHookState] = useState<UseFetchGiftCardStatusForCompanyState>(defaultState);
  const services = useContext(environmentContext);
  useEffect(() => {
    if (!integrationType) return;
    setFetchHookState(defaultState);
    services.ValidationApiClient.fetchGiftCardValidationStatus(integrationType)
      .then((data) => {
        setFetchHookState({
          data,
          loading: false,
        });
      })
      .catch((error) => {
        setFetchHookState({
          data: [],
          error,
          loading: false,
        });
      });
  }, [services, integrationType]);
  return fetchHookState;
};
